export default __webpack_public_path__ + "static/media/headMiiClip.a17303fc.mp4";